<template>
  <div class="contain">
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item><a href="#">Orders</a></el-breadcrumb-item>
      <el-breadcrumb-item><a href="#">Tracking Info</a></el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <!-- orderId title -->
    <div class="order-title">OrderId : {{orderId}}</div>
    <!-- 物流追踪详情页面包含最外层的下单时间和地址信息 -->
    <div class="logistic-detail" v-loading="loading">
      <!-- logistic-order-message -->
      <div class="logistic-order-message">
        <!-- order-place -->
        <div class="order-place">
          <div class="order-place-title">Order Placed</div>
          <div class="order-place-content">{{dataSource.createTime}}</div>
        </div>
         <!-- order-place -->
        <div class="ship-to">
          <div class="ship-to-title">Ship To</div>
          <div class="ship-to-content">{{dataSource.address}}</div>
        </div>
        <div class="logistic-order-message-right" v-if="dataSource.logisticTrackDetail.length && dataSource.logisticTrackDetail.length>1">
          <div class="logistic-order-message-right-content" >The current order has been split and shipped</div>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="no_data" v-if="dataSource.logisticTrackDetail.length ===0">No Logistics Data</div>
      <el-menu
        class="el-menu-vertical-demo"
        :unique-opened="true"
        :default-openeds="['0']">
          <el-submenu v-for="(item,index) in dataSource.logisticTrackDetail" :key="index" :index="index+''" >
            <!-- 菜单的标题 -->
            <template slot="title">
              <!-- 每个物流单号中的信息 -->
              <div class="logistic-children-message">
                <!-- 第一行内容,里面包括 -->
                <div class="logistic-children-message-content">
                  <!-- 物流方式的div -->
                  <div class="shipping-method">
                    <div class="shipping-method-title">Shipping Method:</div>
                    <div class="shipping-method-content">{{item.shippingMethod}}:{{item.trackingNumber}}</div>
                  </div>
                  <!-- 物流状态的div -->
                  <div class="shipping-status">
                    <div class="shipping-status-title">Status:</div>
                    <div class="shipping-status-content">{{item.trackingStatus}}</div>
                  </div>
                  <!-- 每个订单下的数量 -->
                  <div class="order-number">
                    <div class="order-number-title">Items:</div>
                    <div class="order-number-content">{{item.items}}</div>
                  </div>
                </div>
                <!-- 图片部分 -->
                <div class="logistic-children-imgs">
                  <div class="logistic-children-img" v-for="(childrenItem,childrenIndex) in item.skuImgPartList" :key="childrenIndex">
                    <img :src="childrenItem" style="height:80px;width:80px"/>
                  </div>
                  <!-- view all -->
                  <div v-if="item.showViewAll === 1" class="show-view-all-true" @click="showViewAll(item,true)">View All</div>
                  <div v-if="item.showViewAll === 3" class="show-view-all-true" @click="showViewAll(item,false)">Pack Up</div>
                </div>
              </div>
            </template>
            <!-- 菜单的内容 -->
            <el-menu-item-group>
              <template slot="title">
                <!-- 步骤条 -->
                <el-steps class="pc-steps" :active="item.active" finish-status="success">
                  <el-step title="Submit orders" :description="dataSource.createTime"></el-step>
                  <el-step title="Payment completed" :description="item.payTime"></el-step>
                  <el-step title="Warehouse delivery" :description="item.deliveryStartTime"></el-step>
                  <el-step title="Delivered completed" :description="item.deliveredTime"></el-step>
                </el-steps>
                <el-steps class="mobile-steps" direction="vertical" :active="item.active" finish-status="success">
                  <el-step title="Submit orders" :description="dataSource.createTime"></el-step>
                  <el-step title="Payment completed" :description="item.payTime"></el-step>
                  <el-step title="Warehouse delivery" :description="item.deliveryStartTime"></el-step>
                  <el-step title="Delivered completed" :description="item.deliveredTime"></el-step>
                </el-steps>
                <!-- 物流详细进展 -->
                <div class="logistic-steps">
                  <!-- 每一个步骤 -->
                  <div class="steps" v-for="(routes,routesIndex) in item.trackDetail" :key="routesIndex">
                    <div class="logistic-steps-time">{{routes.eventTime}}</div>
                    <div class="logistic-steps-remark">{{routes.locationOfTheIncident.replace('null,','')}} {{routes.eventDescription.replace('null,','')}}</div>
                  </div>
                </div>
              </template>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage.js'
export default {
  data() {
    return {
      showan: true,
      orderId: '',
      loading: false,
      dataSource: {},
      beNetWrok: ''
    }
  },
  created() {
    this.orderId = this.$route.query.orderId
    this.loadData()
  },
  methods: {
    showViewAll(item, flag) {
      if (flag) {
        item.skuImgPartList = item.skuImgAllList
        item.showViewAll = 3
        return
      }
      item.skuImgPartList = item.skuImgAllList.slice(0, 6)
      item.showViewAll = 1
    },
    loadData() {
      this.loading = true
      getAction('/track/info/17track?orderId=' + this.orderId).then(response => {
        if (response.success) {
          // 这里要将图片进行整理，先把所有图片存入一个变量，判断图片的数量是否有6个，如果有则显示view All，如果没有则不显示
          this.handleImg(response.result)
        } else {
          this.$message.warning(response.message)
          this.loading = false
        }
      })
    },
    /**
     * 处理图片
     */
    handleImg(dataSource) {
      if (dataSource.logisticTrackDetail.length && dataSource.logisticTrackDetail.length === 0) {
        this.loading = false
        return
      }
      dataSource.logisticTrackDetail.forEach(item => {
        // 将图片进行分割
        const skuImgAllList = item.skuImgList.split(',')
        item.skuImgAllList = skuImgAllList
        if (skuImgAllList.length > 6) {
          item.showViewAll = 1
          item.skuImgPartList = skuImgAllList.slice(0, 6)
        } else {
          item.showViewAll = 2
          item.skuImgPartList = skuImgAllList
        }
      })
      // 处理完毕后将dataSource赋值
      this.dataSource = dataSource
      this.loading = false
    }
  }
}
</script>

<style lang="less" scoped>
.no_data{text-align: center;height: 200px;line-height: 200px;font-family: Graphik;font-size: 14px;}
.contain{margin-top: 10px;}
.el-divider--horizontal {margin: 15px 0;}
.order-title{width: 100%;text-align: center;height: 100px;line-height: 100px;font-size: 16px;font-family: Graphik;font-weight: 800;color: #000000;opacity: 1;}
/* order-place */
.logistic-detail{width: 100%;border: 1px solid #E1E1E1;padding: 20px;}
.order-place-title{font-size: 14px;font-family: Graphik;font-weight: 500;line-height: 38px;color: #000000;opacity: 1;}
.order-place-content{font-size: 14px;font-family: Graphik;font-weight: 300;line-height: 38px;color: #262B2F;opacity: 1;}
/* shipto */
.ship-to{margin-left: 20px;}
.ship-to-title{font-size: 14px;font-family: Graphik;font-weight: 500;line-height: 38px;color: #000000;opacity: 1;}
.ship-to-content{font-size: 14px;font-family: Graphik;font-weight: 300;line-height: 38px;color: #262B2F;opacity: 1;}
/* 最外层最右侧显示的信息 */
.logistic-order-message{height: 70px;display: flex;}
.logistic-order-message-right{display: flex; align-items: center;margin-left: 400px;color:#FF4812}
.logistic-order-message-right-content{font-size: 14px;font-family: Graphik;font-weight: 500;line-height: 38px;color: #FF4812;opacity: 1;}
/* 菜单部分 */
.el-menu{border: none;}
/deep/ .el-submenu__title{padding-left: 0 !important;font-size: 16px !important;font-family: Graphik;font-weight: 500;color: #000000;opacity: 1;border-bottom:1px solid #E1E1E1;min-height: 130px !important;height: auto !important;}
/deep/ .el-submenu__title:hover{color: #000000 !important;}
/deep/ .el-menu-item-group__title{padding: 0 !important;font-size: 14px !important;font-family: Graphik !important;font-weight: 500 !important;line-height: 34px !important;color: #8F8F8F !important;opacity: 1 !important;}
/* 每一个子物流单号中的信息 */
.logistic-children-message-content{display: flex;}
/* 物流方式 */
.shipping-method{width: 30%;display: flex;}
.shipping-method-title{width: 40%;font-size: 14px;font-family: Graphik;font-weight: 500;line-height: 38px;color: #000000;opacity: 1;}
.shipping-method-content{font-size: 14px;font-family: Graphik;font-weight: 500;line-height: 38px;color: #262B2F;opacity: 1;}
/* 物流状态 */
.shipping-status{margin-left:80px;width: 10%;display: flex;}
.shipping-status-title{width: 40%;font-size: 14px;font-family: Graphik;font-weight: 500;line-height: 38px;color: #000000;opacity: 1;}
.shipping-status-content{font-size: 14px;font-family: Graphik;font-weight: 500;line-height: 38px;color: #262B2F;opacity: 1;}
/* 订单数量 */
.order-number{margin-left:80px;width: 10%;display: flex;}
.order-number-title{width: 40%;font-size: 14px;font-family: Graphik;font-weight: 500;line-height: 38px;color: #000000;opacity: 1;}
.order-number-content{font-size: 14px;font-family: Graphik;font-weight: 500;line-height: 38px;color: #262B2F;opacity: 1;}
/* 图片部分 */
.logistic-children-imgs{display: flex;flex-flow: wrap;}
.logistic-children-img{margin: 10px}
.logistic-children-message{display: flex;flex-direction: column;}
/* 步骤条样式修改 */
/deep/ .el-steps.el-steps--horizontal{width: 70%;}
/deep/ .el-step__head.is-success{color:#000000 !important;border-color: #000000 !important;}
/deep/ .el-step__title.is-success{color:#000000 !important;}
/deep/ .el-step__description.is-success{color:#000000 !important;}
/deep/ .el-step__head.is-process{color:#8F8F8F !important;border-color: #8F8F8F !important;}
/deep/ .el-step__title.is-process{color:#8F8F8F !important;}
/deep/ .el-step__description.is-process{color:#8F8F8F !important;}
.logistic-steps{margin-top:100px}
.steps{display: flex;font-size: 12px;font-family: Graphik;font-weight: 500;line-height: 38px;color: #262B2F;opacity: 1;}
.logistic-steps-remark{width:85%}
.show-view-all-true{background: #E1E1E1;height: 80px;width: 80px;text-align: center;line-height: 80px;margin: 10px;}

.mobile-steps{display: none;}
.logistic-steps-time{width:15%}
@media screen and (max-width: 600px) {
  .contain{width:95%;margin:0 auto;margin-top: 58px;}
  .logistic-order-message{flex-direction: column;height:200px}
  .ship-to{margin-left: 0px;}
  .logistic-detail{width:95%;padding: 10px;}
  .logistic-children-message-content{flex-direction: column;}
  .shipping-method{flex-direction: column;width:100%}
  .shipping-status{margin-left: 0px;width:100%}
  .order-number{margin-left:0px;width:100%}
  .mobile-steps{display: inherit;margin-top: 30px;}
  .pc-steps{display: none;}
  /deep/ .el-step.is-vertical{height:80px !important}
  .logistic-steps-remark{word-wrap:break-word;width:200px;margin-left: 20px;}
  .logistic-steps-time{width:130px}
  .logistic-steps{margin-top:10px}
  /deep/ .el-step.is-vertical .el-step__line{top: 5px !important;}
}
</style>



// WEBPACK FOOTER //
// src/pages/logistics/logistic-detail.vue